import { createContext, useContext } from "react";
import { EMPTY_DATA_CATALOG, FlussDataCatalog } from "modules/fluss/types/data-catalog";

// The authoring catalog (C7) of the node whose panel is open. Provided once by
// FlussNodePropertiesPanel so every DataPicker reads the same source, without threading
// record/variable/previous-result props through every panel.
const DataCatalogContext = createContext<FlussDataCatalog>(EMPTY_DATA_CATALOG);

export const DataCatalogProvider = DataCatalogContext.Provider;
export const useDataCatalogContext = () => useContext(DataCatalogContext);

export default DataCatalogContext;
